/**
 * The contents of this file are subject to the license and copyright
 * detailed in the LICENSE_ATMIRE and NOTICE_ATMIRE files at the root of the source
 * tree and available online at
 *
 * https://www.atmire.com/software-license/
 */
import { Component, Input } from '@angular/core';
import { AtmireSearchResultGridElementComponent } from '../../../../../../../app-atmire/shared/object-grid/search-result-grid-element/atmire-search-result-grid-element.component';
import { Context } from '../../../../../../../app/core/shared/context.model';
import { CommunitySearchResult } from '../../../../../../../app/shared/object-collection/shared/community-search-result.model';
import { LinkService } from '../../../../../../../app/core/cache/builders/link.service';
import { TruncatableService } from '../../../../../../../app/shared/truncatable/truncatable.service';
import { MultilingualMetadataService } from '../../../../../../../app-atmire/core/shared/multilingual-metadata.service';
import { ViewMode } from '../../../../../../../app/core/shared/view-mode.model';
import { hasNoValue, hasValue } from '../../../../../../../app/shared/empty.util';
import { Community } from '../../../../../../../app/core/shared/community.model';
import { listableObjectComponent } from '../../../../../../../app/shared/object-collection/shared/listable-object/listable-object.decorator';
import { BitstreamDataService } from '../../../../../../../app/core/data/bitstream-data.service';
import { followLink } from '../../../../../../../app/shared/utils/follow-link-config.model';

@Component({
  selector: 'ds-community-search-result-grid-element',
  styleUrls: [
    '../../../../../../../app/shared/object-grid/search-result-grid-element/search-result-grid-element.component.scss',
    'community-search-result-grid-element.component.scss',
  ],
  templateUrl: 'community-search-result-grid-element.component.html',
})
/**
 * Component representing a grid element for a community search result
 */
@listableObjectComponent(CommunitySearchResult, ViewMode.GridElement, Context.Any, 'atmire')
export class CommunitySearchResultGridElementComponent extends AtmireSearchResultGridElementComponent<CommunitySearchResult,Community> {
  private _dso: Community;
  constructor(
    private linkService: LinkService,
    protected truncatableService: TruncatableService,
    protected bitstreamDataService: BitstreamDataService,
    protected multilingualMetadataService: MultilingualMetadataService,
  ) {
    super(truncatableService, bitstreamDataService, multilingualMetadataService);
  }

  // @ts-ignore
  @Input() set dso(dso: Community) {
    this._dso = dso;
    if (hasValue(this._dso) && hasNoValue(this._dso.logo)) {
      this.linkService.resolveLink<Community>(this._dso, followLink('logo'));
    }
  }

  get dso(): Community {
    return this._dso;
  }
}
